import {
  Select,
  SelectOption,
  InputCounter,
  Button,
  Icon,
} from '@data-products-and-ai/react-components';
import React, { ChangeEvent, useEffect } from 'react';
import dropdownData from '../../utils/dropdown_data.json';

interface SelectionBidParams {
  setSelectionBid: (value: object) => void;
}

interface SelectedBid {
  incoterms: string | undefined;
  price_types: string | undefined;
  country_offer: string | undefined;
  country_installation: string | undefined;
  materials: SelectedMaterial[];
}

interface SelectedMaterial {
  material: string | undefined;
  numberOfBreakers: number | undefined;
  pricePerPiece: number | undefined;
}

const color = '#8a00e5';

const SelectionBid: React.FC<SelectionBidParams> = ({ setSelectionBid }) => {
  const [isAddMaterial, setIsAddMaterial] = React.useState(false);
  const [selectedBid, setSelectedBid] = React.useState<SelectedBid>({
    incoterms: dropdownData['incoterms'][0],
    price_types: dropdownData['price_types'][0],
    country_offer: dropdownData['countries'][0],
    country_installation: dropdownData['countries'][0],
    materials: [
      {
        material: dropdownData['materials'][0],
        numberOfBreakers: 1,
        pricePerPiece: 1,
      },
    ],
  });

  useEffect(() => {
    if (isAddMaterial) {
      setSelectedBid((prevSelectedBid) => ({
        ...prevSelectedBid,
        materials: [
          ...prevSelectedBid.materials,
          {
            material: dropdownData['materials'][0],
            numberOfBreakers: 1,
            pricePerPiece: 1,
          },
        ],
      }));
    } else {
      if (selectedBid.materials.length > 1) {
        setSelectedBid((prevSelectedBid) => ({
          ...prevSelectedBid,
          materials: prevSelectedBid.materials.slice(0, -1),
        }));
      }
    }
  }, [isAddMaterial]);

  const handleSubmit = () => {
    console.log(selectedBid);
    setSelectionBid(selectedBid);
  };

  const handleChangeSelector = (
    event: ChangeEvent<HTMLSelectElement>,
    materialNumber?: number,
  ) => {
    if (materialNumber) {
      const materials = selectedBid.materials;
      let material = materials[materialNumber - 1];
      material = {
        ...material,
        material: event.target.value,
      };
      materials[materialNumber - 1] = material;
      setSelectedBid((prevSelectedBid) => ({
        ...prevSelectedBid,
        materials: materials,
      }));
    } else {
      setSelectedBid((prevSelectedBid) => ({
        ...prevSelectedBid,
        [materialNumber ? materialNumber - 1 : event.target.id]:
          event.target.value,
      }));
    }
  };

  const handleChangeCounter = (value: number, property: string) => {
    const materialNumber: number = Number(property?.split('_')[1]);
    property = property?.split('_')[0];

    const materials = selectedBid.materials;
    let material = materials[materialNumber-1];
    material = {
      ...material,
      [property]: value,
    };
    materials[materialNumber-1] = material;
    setSelectedBid((prevSelectedBid) => ({
      ...prevSelectedBid,
      materials: materials,
    }));
  };

  return (
    <div className="selectionBid">
      <h4>Select Bid Options</h4>
      <div className="selectionBid-section">
        <div className="selectionBid-section__two">
          <div>
            <Select
              label="What is the Incoterm?"
              id="incoterms"
              onChange={handleChangeSelector}
            >
              {dropdownData['incoterms'].map((item, index) => (
                <SelectOption key={index} label={item} value={item} />
              ))}
            </Select>
          </div>
          <div>
            <Select
              label="What is the Price Type?"
              id="price_types"
              onChange={handleChangeSelector}
            >
              {dropdownData['price_types'].map((item, index) => (
                <SelectOption key={index} label={item} value={item} />
              ))}
            </Select>
          </div>
        </div>
        <div className="selectionBid-section__two">
          <div>
            <Select
              label="What is the Offer Country?"
              id="country_offer"
              onChange={handleChangeSelector}
            >
              {dropdownData['countries'].map((item, index) => (
                <SelectOption key={index} label={item} value={item} />
              ))}
            </Select>
          </div>
          <div>
            <Select
              label="What is the Installation Country?"
              id="country_installation"
              onChange={handleChangeSelector}
            >
              {dropdownData['countries'].map((item, index) => (
                <SelectOption key={index} label={item} value={item} />
              ))}
            </Select>
          </div>
        </div>
        <div className="selectionBid-section__three">
          <div>
            <Select
              label="Position 1 Material?"
              id="material_1"
              onChange={(event) => handleChangeSelector(event, 1)}
            >
              {dropdownData['materials'].map((item, index) => (
                <SelectOption key={index} label={item} value={item} />
              ))}
            </Select>
          </div>
          <div>
            N. of Breakers Pos1?
            <InputCounter
              defaultValue={1}
              min={0}
              id="numberOfBreakers"
              onChange={(value) =>
                handleChangeCounter(value, 'numberOfBreakers_1')
              }
            />
          </div>
          <div>
            Price/Piece Pos1?
            <InputCounter
              id="pricePerPiece"
              defaultValue={1}
              min={0}
              onChange={(value) =>
                handleChangeCounter(value, 'pricePerPiece_1')
              }
            />
          </div>
        </div>
        {!isAddMaterial ? (
          <div className="selectionBid-button">
            <Button
              type="primaryOutline"
              allCaps={false}
              size="large"
              icon={<Icon icon="IconPlus" iconSize={0.9} color={color} />}
              onClick={() => setIsAddMaterial(!isAddMaterial)}
            >
              Add Material
            </Button>
          </div>
        ) : (
          <div className="selectionBid-section__four">
            <Button
              type="headless"
              allCaps={false}
              size="large"
              icon={<Icon icon="IconTrash" iconSize={0.9} color={'red'} />}
              onClick={() => setIsAddMaterial(!isAddMaterial)}
            />
            <div>
              <Select
                id="positionMaterial2"
                label="Position 2 Material?"
                onChange={(event) => handleChangeSelector(event, 2)}
              >
                {dropdownData['materials'].map((item, index) => (
                  <SelectOption key={index} label={item} value={item} />
                ))}
              </Select>
            </div>
            <div>
              N. of Breakers Pos2?
              <InputCounter
                id="numberOfBreakers2"
                defaultValue={1}
                min={0}
                onChange={(value) =>
                  handleChangeCounter(value, 'numberOfBreakers_2')
                }
              />
            </div>
            <div>
              Price/Piece Pos2?
              <InputCounter
                id="pricePerPiece2"
                defaultValue={1}
                min={0}
                onChange={(value) =>
                  handleChangeCounter(value, 'pricePerPiece_2')
                }
              />
            </div>
          </div>
        )}
        <div className="selectionBid-button">
          <Button
            type="primaryNoShadow"
            allCaps={false}
            size="large"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectionBid;
